import React from 'react';
import {Control, FieldValues, UseFormSetValue} from 'react-hook-form';
import FormDateRange from '../FormDateRange';
import {Box, Typography, Button} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface Props {
  control: Control<FieldValues>;
  setValue: UseFormSetValue<any>;
}

const SessionDatesFilter: React.FC<Props> = ({control, setValue}) => {
  const {t} = useTranslation();
  return (
    <Box>
      <Typography variant="h4" sx={{mb: 2}}>
        {t('sessionFilter.sessionDates')}
      </Typography>
      <Box sx={{mb: 2, display: 'flex', gap: 2}}>
        <FormDateRange
          label={t('sessionFilter.sessionDates') as string}
          control={control as unknown as Control<FieldValues>}
          name="dateRange"
          sx={{flex: 1}}
        />
        <Button onClick={() => setValue('dateRange', null)}>
          {t('general.clear')}
        </Button>
      </Box>
    </Box>
  );
};

export default SessionDatesFilter;
